import styled from "styled-components";

export const Page = styled.div`
  .mui-selected: {
    background: "red";
  }
`;
